import './repairmaintenance.css';

const RepairMaintenance = () => {
    return (
        <h1>RepairMaintenance</h1>
    )
}

export default RepairMaintenance;
